import React from 'react'
import { Subscription } from '../store/store'
import './SubscriptionRowCompact.css'
import { RequestState } from '../../types'
import SubscriptionAccountsCompact from './SubscriptionAccountsCompact'
import slugify from 'react-slugify'
import PropertyGrid from '../../../components/PropertyGrid'
import { useTranslation } from 'react-i18next'
import Date from '../../../components/Date'

type Props = {
  subscription: Subscription
  loadSubscriptionDetails: (subscriptionId: string) => Promise<void>
  setSubscriptionExpanded: (subscriptionId: string, expanded: boolean) => void
  loadSubscriptionAccountFilters: (subscriptionId: string, accountId: string) => Promise<void>
}

function SubscriptionRowCompact(props: Props) {
  const {
    subscription,
    loadSubscriptionDetails,
    setSubscriptionExpanded,
    loadSubscriptionAccountFilters
  } = props

  function toggleExpand() {
    setSubscriptionExpanded(subscription.id, !subscription.isExpanded)

    if (subscription.requestState === RequestState.NotLoaded) {
      loadSubscriptionDetails(subscription.id)
    }
  }

  const { t } = useTranslation(['subscriptions', 'global'])

  return (
    <>
      <div id={`${slugify(subscription.name)}-compact-header`} className="header-cell flex-justify-start">
        <b>{subscription.name}</b>
        <div className="action-container">
          <a href={`${process.env.REACT_APP_WEPAPP_URL}/subscriptions/${subscription.id}/overview`} target="_blank" rel="noopener noreferrer">
            <i className="far fa-window-maximize icon-button web-expand"></i>
          </a>
          <a href={`${process.env.REACT_APP_MAINFRAME_URL}/subscriptions/${subscription.id}`} target="_blank" rel="noopener noreferrer">
            <i className="fas fa-cog icon-button"></i>
          </a>
        </div>
      </div>
      <div className="padding-s" data-cy={`subscription-${slugify(subscription.name)}`}>
        <PropertyGrid properties={{
          [t('fields.package')]: subscription.package,
          [t('fields.records')]: `${subscription.records} / ${subscription.recordAllowance}`,
          [t('fields.members')]: (
            <span>
              {subscription.members}
              {subscription.invitations > 0 ? `(+${subscription.invitations})` : ''}
              {' / '}
              {subscription.memberAllowance}            
            </span>
          ),
          [t('fields.renewal')]: <Date date={subscription.renewal as Date} />
        }} />

        <div className="spacing-top-xs" data-cy="expand-compact" onClick={toggleExpand}>{t('global:view_more')}&nbsp;
          {subscription.isExpanded && (
            <i onClick={toggleExpand} className="fa fa-chevron-down expand" aria-hidden="true"></i>
          )}

          {!subscription.isExpanded && (
            <i onClick={toggleExpand} className="fa fa-chevron-right expand" aria-hidden="true"></i>
          )}
        </div>

        {subscription.isExpanded && (
          <div className="spacing-top-xs">
            <SubscriptionAccountsCompact
              subscription={subscription}
              loadSubscriptionAccountFilters={loadSubscriptionAccountFilters} />
          </div>
        )}
      </div>
    </>
  )
}

export default SubscriptionRowCompact
